import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 1.26A6.75 6.75 0 1 0 14.74 8 6.76 6.76 0 0 0 8 1.26Zm.75 10.16a.75.75 0 1 1-1.5 0V8.63a.75.75 0 0 1 1.5 0ZM8 6a1.12 1.12 0 1 1 1.12-1.12A1.12 1.12 0 0 1 8 6Z';
const draw24px =
  'M12,2.25A9.75,9.75,0,1,0,21.76,12,9.76,9.76,0,0,0,12,2.25Zm1,14.88a1,1,0,0,1-2,0V12.5a1,1,0,0,1,2,0ZM12,9.22a1.34,1.34,0,1,1,1.34-1.34A1.34,1.34,0,0,1,12,9.22Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ICircleFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'iCircleFilled')) as IconWithRender;

ICircleFilledIcon.displayName = 'ICircleFilledIcon';
ICircleFilledIcon.propTypes = Icon.propTypes;
ICircleFilledIcon.renderIcon = (props) => <ICircleFilledIcon {...props} />;
export default ICircleFilledIcon;
